import {Image, forwardRef} from '@chakra-ui/react';

export default forwardRef(function ChakraImage(props, ref) {
    return <Image {...props} ref={ref} />;
});
